import React, { memo } from 'react'
import './SwitchButton.scss'

const SwitchButton = (props) => {
  const { className = '', onChange, disabled, checked, value } = props
  return <input type='checkbox' disabled={disabled} checked={checked} onChange={onChange} value={value} className={`custom-switch ${className}`} />
}

export default memo(SwitchButton)
